'use client'
import { styled } from "@phntms/css-components";
import Image from "next/image"
import styles from "./styles.module.scss";

export const BgImage = styled(Image, {
  css: styles.bgImage
})

